import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  fetchAppliedCandidates,
  setAppliedCandidatesLoading,
  showFilterModal,
  updateFilters,
  updatePagination,
  deSelectAllCandidate,
} from "@/reducers/client_candidates/candidatesapplied";
import { getIsFilterApplied } from "@/utilities/utils";

import TableSearch from "../../../dataTables/TableSearch";
import FilterButton from "../../../ListingFilters/FilterButton";

/**
 * SearchFilter component for filtering and searching applied candidates.
 *
 * @param {Event} e - The event object
 * @return {JSX.Element} The search filter component
 */
export const SearchFilter = () => {
  const { filters, pagination } = useSelector(
    (state) => state.clientCandidatesApplied,
  );
  const filterApplied = getIsFilterApplied(filters);
  const dispatch = useDispatch();
  /**
   * Handles the search event.
   *
   * @param {Event} e - the event object
   * @return {void}
   */
  const handleSearch = (e) => {
    dispatch(updateFilters({ search: e.target.value }));
  };
  const firstUpdate = useRef(true);
  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    const delayDebounceFn = setTimeout(() => {
      dispatch(setAppliedCandidatesLoading(true));
      dispatch(
        updatePagination({
          ...pagination,
          currentPage: 1,
          isLastPage: false,
        }),
      );
      dispatch(deSelectAllCandidate());
      dispatch(fetchAppliedCandidates(filters));
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [filters.search]);

  return (
    <div className="SearchFilter_Wrapper">
      <div className="flex gap-[20px]">
        <TableSearch val={filters.search} handleChange={handleSearch} />
        <FilterButton
          filterApplied={filterApplied}
          handleClick={() => {
            dispatch(showFilterModal(true));
          }}
        />
      </div>
    </div>
  );
};
